import PropertyPage from './Properties/PropertyPage';
import PropertiesPage from './Properties/PropertiesPage';
import FieldsPage from './Fields/FieldsPage';
import Dashboard from './Dashboard/Dashboard';
import SettingsPage from './Settings/SettingsPage';
import ProductionPage from './Production/ProductionPage';
import AdminPage from './Admin/AdminPage';
import HelpPage from './Help/HelpPage';
import PlansPage from './Plans/PlansPage';
import DeviceManagementPage from './Devices/DeviceManagementPage';
import EventsPage from './Events/EventsPage';

export {
  PropertiesPage,
  PropertyPage,
  SettingsPage,
  Dashboard,
  FieldsPage,
  DeviceManagementPage,
  ProductionPage,
  AdminPage,
  HelpPage,
  PlansPage,
  EventsPage,
};
